import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  MINI_MENU_NEED_HELP,
  RETURN_PORTAL_SUBTEXT_ONE,
  RETURN_PORTAL_SUBTEXT_TWO,
  RETURN_PORTAL_SUBTEXT_THREE,
  START_RETURN,
  TRACK_RETURN,
  VIEW_FULL_POLICY,
} from '../../config/text/text';
import { trackEvent } from '../../helpers/analytics';
import { isReturnInProgress } from '../../helpers/vouchers';
import { createReturnOrder } from '../../services/vouchers';
import CTAButton from '../_generic/button/CTAButton';
import useToast from '../_generic/toast/UseToast';
import ReturnsPortalRefundOptions from './ReturnsPortalRefundOptions';

const ReturnsPortal = ({ voucher }) => {
  const toast = useToast();
  const router = useRouter();
  const [returnOrderLink, setReturnOrderLink] = useState('');
  const [isCashRefund, setIsCashRefund] = useState(null);
  const trackingUrl = voucher?.returnsPortal?.trackingUrl;
  const category = voucher?.returnsPortal?.category;

  const handleCashRefund = () => {
    if (isCashRefund) {
      setIsCashRefund(false);
    } else {
      setIsCashRefund(true);
    }
  };

  const openReturnPortal = async () => {
    trackEvent('myaccount-startareturn');
    if (returnOrderLink) {
      window.open(returnOrderLink, '_blank');
    } else {
      try {
        const response = await createReturnOrder(
          voucher.voucherCode,
          isCashRefund,
        );
        window.open(response.data.url, '_blank');
        setReturnOrderLink(response.data.url);
      } catch {
        toast.addToast(
          <div>
            <div>Something went wrong</div>
            <div>Please try again later.</div>
          </div>,
          'toast-error',
        );
      }
    }
  };

  return (
    <>
      <div className="returns__subtext">{RETURN_PORTAL_SUBTEXT_ONE}</div>
      <div className="returns__subtext">{RETURN_PORTAL_SUBTEXT_TWO}</div>
      {category === 'electronics' && (
        <div className="returns__subtext">
          <b>{RETURN_PORTAL_SUBTEXT_THREE}</b>
        </div>
      )}
      <ReturnsPortalRefundOptions
        currency={voucher.currency}
        handleCashRefund={handleCashRefund}
        isCashRefund={isCashRefund}
        returnsPortal={voucher.returnsPortal}
      />
      <div className="returns__actions">
        {isReturnInProgress(voucher) && trackingUrl ? (
          <Link href={trackingUrl} passHref>
            <CTAButton className="secondary-button">{TRACK_RETURN}</CTAButton>
          </Link>
        ) : (
          <CTAButton className="secondary-button" onClick={openReturnPortal}>
            {START_RETURN}
          </CTAButton>
        )}
        <Link href={MINI_MENU_NEED_HELP[process.env.NEXT_PUBLIC_SITE]} passHref>
          <span className="underline-link">{VIEW_FULL_POLICY}</span>
        </Link>
      </div>

      <style jsx>{`
        .returns__subtext {
          margin: 2rem 0;
        }
        .returns__actions {
          margin: 0.5rem 0;
          display: flex;
          gap: 0.5rem;
          align-items: center;
          flex-direction: column;
          justify-content: center;
        }
        .underline-link {
          text-decoration: underline;
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

ReturnsPortal.propTypes = {
  voucher: PropTypes.object.isRequired,
};

export default ReturnsPortal;
